import { defineComponent as _defineComponent } from 'vue'
import { getJobStatusName } from '@/utils/status-formatting'
import { computed } from 'vue'
import VsAlert from '@/components/vision/VsAlert.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'JobReadonlyBanner',
  props: {
    isArchived: { type: Boolean, default: false },
    jobStatus: { default: '' },
    hubId: { default: '' }
  },
  setup(__props: any) {

const props = __props as { isArchived: boolean, jobStatus: string, hubId: string }



const iconInfo = computed(() =>
  props.isArchived
    ? { icon: 'mdi-archive-arrow-down-outline', class: 'pb-1 pr-1' }
    : null
)

const message = computed(() =>
  props.isArchived
    ? 'Job Archived. It can no longer be changed'
    : `Job ${getJobStatusName(props.jobStatus)}. It can no longer be changed`
)

return { __sfc: true,props, iconInfo, message, VsAlert, VsWrapper }
}

})